/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable */
import ReactDOM from 'react-dom'
// Redux
// https://github.com/rt2zz/redux-persist
import { Provider } from 'react-redux'
import * as _redux from './setup'
import store from './setup/redux/Store'

import * as Sentry from '@sentry/react'
import { browserTracingIntegration } from "@sentry/react"
import SentryErrorBoundary from './components/SentryErrorBoundary'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [browserTracingIntegration, Sentry.replayIntegration()],
  environment: 'production',
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0,
  enabled: process.env.REACT_APP_SENTRY_ENABLED === 'true',
})
// Axios
import axios from 'axios'

// Apps
import { App } from './app/App'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/sass/style.scss'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store)

ReactDOM.render(
  <SentryErrorBoundary>
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      {/* <PersistGate persistor={persistor} loading={<div>Loading...</div>}> */}
        <App basename={PUBLIC_URL} />
      {/* </PersistGate> */}
    </Provider>
  </SentryErrorBoundary>,
  document.getElementById('root')
)
